<template>
  <a-select
    allowClear
    :mode="mode"
    show-search
    :maxTagCount="4"
    :placeholder="_selfPlaceholder"
    :disabled="_selfDisabled"
    v-model="selectedValue"
    :filter-option="filterOption"
    @change="onChange"
  >
    <a-select-option v-for="(item, index) in option" :value="item.code" :key="index">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import api from '@/service/api'
import http from '@/service/axios'
export default {
  mounted() {
    this.getList()
  },
  props: {
    placeholder: {},
    disabled: {},
    code: {},
    name: {},
    mode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedValue: undefined,
      option: [],
    }
  },
  computed: {
    _selfPlaceholder() {
      return this.placeholder || this.$t(`结算组织`)
    },
    _selfDisabled() {
      return this.disabled || false
    },
  },
  methods: {
    async getList() {
      let res = await http({
        url: api.getDepartmentList,
        type: 'post',
        data: { needFinancialSettlement: 1 },
      })
      let list = res.result || []
      this.option = list
      if (this.code != undefined) {
        this.onChange(this.code)
      }
    },
    onChange(value) {
      this.selectedValue = value
      this.$emit('update:code', value)
      let item = this.option.find((elem) => elem.code === value)
      this.$emit('update:name', item?.name)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
  watch: {
    code(val) {
      this.selectedValue = val
    },
  },
}
</script>
